import { createSlice } from '@reduxjs/toolkit';

const changePhotoSlice = createSlice({
  name: 'changePhoto',
  initialState: {},
  reducers: {
    getThumbImg: () => {},
    getThumbImgSuccess: (state, { payload }) => {
      state.thumbnailInfo = payload;
      state.responseStatus = false;
    },

    addPhotoRegister: state => {
      state.responseStatus = false;
    },
    addPhotoRegisterSuccess: state => {
      state.responseStatus = true;
    },

    setRpstPhotoTypeCd: (state, { payload }) => {
      state.thumbnailInfo.rpstPhotoTypeCd = payload;
    },
    getImageEditorDomain: () => {},
    getImageEditorDomainSuccess: (state, { payload }) => {
      state.imageEditorDomain = payload.value;
    },
  },
});

export const {
  getThumbImg,
  getThumbImgSuccess,
  addPhotoRegister,
  addPhotoRegisterSuccess,
  setRpstPhotoTypeCd,
  getImageEditorDomain,
  getImageEditorDomainSuccess,
} = changePhotoSlice.actions;
export default changePhotoSlice.reducer;
